import '../styles/Header.css';
import logo from '../assets/img/logo-abbvie-vraie-vie.png';
import { Link } from 'react-router-dom';
import Menu from './Menu';

function toggleMenu() {
  let body = document.querySelector('body');
  let hamburgerMenu = document.querySelector('.hamburger-menu');
  let navMenu = document.querySelector('.site-header nav');
  body.classList.toggle('fixed');
  hamburgerMenu.classList.toggle('active');
  navMenu.classList.toggle('open');
}

function Header() {
  return (
    <header className='site-header'>
      <h1><Link to='/'><img src={logo} alt='Abbvie Vraie Vie'/></Link></h1>
      <nav>
        <Menu />
      </nav>
      <button className='hamburger-menu' aria-label='Hamburger Menu' onClick={() => toggleMenu()}>
        <span></span>
        <span></span>
        <span></span>
      </button>
    </header>
  )
}

export default Header